module.exports = __webpack_public_path__ + "img/pirouetti.5ecacd73.png";